export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";